<template>
    <div class="w-full">
      <div class="w-full flex justify-between items-center">
        <Back />
        <a @click.prevent="nextStep"
          class="focus:outline-none cursor-pointer text-white text-sm py-1 px-2 rounded-md bg-red-500 hover:bg-red-600 hover:shadow-lg flex items-center">
          Selanjutnya : {{whatsNext == '' ? 'Selesai' : 'Tambah ' + whatsNext}}
          <i class="fas fa-arrow-right ml-2"></i>
        </a>
      </div>
      <div>
        <Step :classroom="classroom" :step="step" />
      </div>
      <div class="md:grid md:grid-cols-5 md:gap-2">
        <div class="md:col-span-2 ">
          <div class="flex justify-between my-3">
            <p class="self-center">Daftar Quiz</p>
            <a @click.prevent="addQuizzes" type="button"
              class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm">
              Tambah Quiz
            </a>
          </div>

          <DataTable :value="quizzes" @rowReorder="onRowReorder" responsiveLayout="scroll" v-model:selection="selectedQuiz"
            selectionMode="single" @rowSelect="onRowSelect" class="shadow p-datatable-sm font-sans text-sm">
            <template #empty>
              No Data found.
            </template>
            <template #loading>
              Loading quiz data. Please wait.
            </template>
            <Column selectionMode="single" headerStyle="width: 3em"></Column>

            <Column v-for="col of columns" :field="col.field" :header="col.header" :key="col.field"></Column>
            <Column field="name" header="Judul">
              <template #body="{data}">
                {{data.name}}
                <span v-if="data.is_exam" class="text-red-500">(Ujian)</span>

              </template>
            </Column>
            <Column field="min_score" header="KKM"></Column>
            <Column field="id" header="Aksi">
              <template #body="{data}">
                <a @click="showEditQuiz(data)" type="button"
                  class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-yellow-500 text-base font-medium text-white hover:bg-yellow-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 sm:ml-3 sm:w-auto sm:text-sm">
                  <i class="fas fa-edit"></i>
                </a>
                <a @click="showDeleteQuiz(data.id)" type="button"
                  class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-2 py-1 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                  <i class="fas fa-trash-alt"></i>
                </a>
              </template>
            </Column>
            <Column :rowReorder="true" headerStyle="width: 1rem" :reorderableColumn="false" />
          </DataTable>
        </div>
        <div class="md:col-span-3 ">
          <div class="flex justify-between my-3">
            <p class="self-center">Daftar Pertanyaan ({{selectedQuiz?.name}})</p>
            <a @click.prevent="addQuestions" type="button"
              class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white bg-indigo-600 hover:bg-indigo-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600 sm:ml-3 sm:w-auto sm:text-sm"
              disabled>
              Tambah Soal
            </a>
          </div>
          <DataTable :value="questionList" :paginator="true" :rows="10" dataKey="id" :rowHover="true"
            filterDisplay="menu" v-model:filters="filters" :loading="isLoadingQuiz"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[10, 25, 50]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" responsiveLayout="scroll"
            class="p-datatable-sm font-sans text-sm">

            <template #empty>
              No Data found.
            </template>
            <template #loading>
              Loading quiz data. Please wait.
            </template>
            <!-- <Column field="id" header="ID" ></Column> -->
            <Column field="question" header="Soal"></Column>
            <Column field="choices" header="Pilihan Jawaban">
              <template #body="{data}">
                <ul v-for="(q, i) in listQuestion(data.choices)" :key="i">
                  <li :class="i === data.answer ? 'text-red-600 font-bold':''">• {{q}}</li>
                </ul>
              </template>
            </Column>
            <Column field="point" header="Poin"></Column>

            <Column field="id" header="Aksi">
              <template #body="{data}">
                <a @click.prevent="editQuestions(data.id)" type="button"
                  class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm p-2 text-base font-medium text-white bg-yellow-500 hover:bg-yellow-600 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                  <i class="fas fa-edit"></i>
                </a>
                <a @click.prevent="showDeleteQuestion(data.id)" type="button"
                  class="w-full cursor-pointer inline-flex justify-center rounded-md border border-transparent shadow-sm p-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm">
                  <i class="fas fa-trash-alt"></i>
                </a>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <!-- modal question -->
      <transition name="pop">
      <div v-if="displayModal"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
        <div class="relative w-3/4 md:w-1/3 m-auto">
          <div
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none max-h-85">
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
              <h3 class="text-xl font-semibold text-white">
                {{ questionId > 0 ? 'Ubah Pertanyaan' : 'Tambah Pertanyaan'}}
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeModal()">
                <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
              </button>
            </div>
            <div class="relative px-6 py-3 overflow-y-auto">
              <div v-if="questionId == 0 " class="w-full pb-3 text-center">
                <div class="bg-gray-200 text-sm text-gray-500 leading-none border-2 border-gray-200 rounded-full inline-flex">
                  <button class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none px-4 py-2" :class="!importFile ? 'bg-white text-green-600 rounded-full font-bold' : 'hover:text-gray-600 focus:text-gray-600 rounded-l-full'" @click="importFile = false" id="grid">
                    <i class="fas fa-keyboard mr-2"></i>
                    <span>Tambah Manual</span>
                  </button>
                  <button class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none px-4 py-2" :class="importFile ? 'bg-white text-indigo-600 rounded-full font-bold' : 'hover:text-gray-600 focus:text-gray-600 rounded-r-full'" @click="importFile = true" id="list">
                    <i class="fas fa-file-upload mr-2"></i>
                    <span>Import File</span>
                  </button>
                </div>
              </div>
              <div v-if="importFile">
                <div class="w-full pb-3">
                  <label for="" class="block text-sm font-medium text-gray-700">
                    Pilih File
                  </label>
                  <div class="mt-1">
                    <label 
                      class="w-full flex flex-col items-center px-4 py-6 rounded-md shadow-xm tracking-wide cursor-pointer"
                      :class="selectedFile ? 'bg-indigo-600 text-white' : 'bg-white text-indigo-600 border border-gray-300 hover:text-indigo-800'"
                    >
                      <svg v-if="!selectedFile" class="w-9 h-9" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                          <path d="M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" />
                      </svg>
                      <svg v-else class="w-9 h-9" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"></path></svg>
                      <span class="mt-1 text-base leading-normal font-semibold">{{ selectedFile ? selectedFile.name : 'Pilih file CSV' }}</span>
                      <span v-if="selectedFile" class="mt-2 text-xs font-medium underline">Ubah File</span>
                      <input type='file' class="hidden" @change="onFileChange"/>
                      
                    </label>
                  </div>
                  <p class="text-xs text-gray-500 mt-2">Sampel File: untuk sampel bisa <a href="/files/format-quiz.csv" download class="text-blue-600">unduh disini</a>. Wajib menggunakan <span class="font-semibold">field delimiter ;</span> dan <span class="font-semibold">jangan hapus kolom pertama</span> pada sampel</p>
                </div>
              </div>
              <div v-else>
                <div class="w-full pb-3">
                  <label for="question" class="block text-sm font-medium text-gray-700">
                    Pertanyaan
                  </label>
                  <div class="mt-1">
                    <textarea v-model="payload.question" id="question" name="question" rows="3"
                      class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                      placeholder="Masukkan Pertanyaan"></textarea>
                  </div>
                </div>

                <div class="w-full pb-3">
                  <label for="country" class="block text-sm font-medium text-gray-700">Pilih Format Jawaban</label>
                  <select id="format" name="format" autocomplete="format" v-model="format"
                    class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                    <option value="trueFalse">Benar atau Salah</option>
                    <option value="multiple">Pilihan Ganda</option>
                  </select>
                </div>

                <div v-if="format === 'trueFalse'" class="w-full pb-3">
                  <label for="trueFalseAnswer" class="block text-sm font-medium text-gray-700">Pilih Jawaban yang
                    benar</label>
                  <div class="flex items-center mt-2">
                    <input id="true" name="trueFalseAnswer" v-model="selectedAnswer" value="0" type="radio"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer">
                    <label for="true" class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer">
                      Benar
                    </label>
                  </div>
                  <div class="flex items-center mt-2">
                    <input id="false" name="trueFalseAnswer" v-model="selectedAnswer" value="1" type="radio"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer">
                    <label for="false" class="ml-3 block text-sm font-medium text-gray-700 cursor-pointer">
                      Salah
                    </label>
                  </div>

                </div>
                <div v-else class="w-full pb-3">
                  <label for="multiple" class="block text-sm font-medium text-gray-700">Masukkan Jawaban dan Pilih Jawaban
                    yang benar</label>
                  <div class="flex items-center mt-2">
                    <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="0"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer">
                    <input type="text" placeholder="pilihan jawaban 1"
                      class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      v-model="answer[0]" />
                  </div>
                  <div class="flex items-center mt-2">
                    <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="1"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer">
                    <input type="text" placeholder="pilihan jawaban 2"
                      class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      v-model="answer[1]" />
                  </div>
                  <div class="flex items-center mt-2">
                    <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="2"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer">
                    <input type="text" placeholder="pilihan jawaban 3"
                      class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      v-model="answer[2]" />
                  </div>
                  <div class="flex items-center mt-2">
                    <input id="true" name="multiple" v-model="selectedAnswer" type="radio" value="3"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 cursor-pointer">
                    <input type="text" placeholder="pilihan jawaban 4"
                      class="mt-1 ml-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                      v-model="answer[3]" />
                  </div>
                </div>

                <div class="w-full pb-3">
                  <label for="point" class="block text-sm font-medium text-gray-700">
                    Point
                  </label>
                  <div class="mt-1">
                    <input name="point" id="point" type="number" v-model="payload.point"
                      class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right px-6 py-3">
              <button @click.prevent="submitQuestion"
                :class="questionId > 0 ? 'text-white bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600' : 'text-white bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'"
                class="inline-flex justify-center border border-solid font-bold text-sm px-3 py-2 rounded outline-none focus:outline-none"
                type="button" style="transition: all .15s ease">
                {{ importFile ? 'Import' : questionId ? 'Ubah' : 'Tambah' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      </transition>

      <!-- modal quiz -->
      <transition name="pop">
      <div v-if="displayModalQuiz"
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex">
        <div class="relative w-3/4 md:w-1/3 my-6 mx-auto">
          <div
            class="border-0 rounded-lg shadow-2xl relative flex flex-col w-full bg-white outline-none focus:outline-none">
            <div
              class="flex items-start justify-between items-center p-3 border-b border-solid border-gray-300 rounded-t bg-indigo-700">
              <h3 class="text-xl font-semibold text-white">
                {{ quizId > 0 ? 'Ubah Quiz' : 'Tambah Quiz' }}
              </h3>
              <button
                class="p-1 ml-auto bg-transparent border-0 text-black float-right text-xl leading-none font-semibold outline-none focus:outline-none"
                v-on:click="closeModalQuiz()">
                <i class="fas fa-times h-5 w-5 text-white outline-none focus:outline-none"></i>
              </button>
            </div>
            <div class="relative px-6 pt-3 pb-6">
            <InlineMessage v-if="quizId == 0" class="w-full text-left" :severity="isThereExam ? 'success' : 'warn'">{{isThereExam ? 'Kelas ini sudah memiliki Ujian' : 'Kelas ini belum memiliki Ujian'}}</InlineMessage>
              <div class="w-full pb-3">
                <label for="name" class="block text-sm font-medium text-gray-700">
                  Nama
                </label>
                <div class="mt-1">
                  <textarea v-model="formQuiz.name" id="name" name="name" rows="3"
                    class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                    placeholder="Masukkan Nama quiz"></textarea>
                </div>
              </div>

              <div class="w-full pb-3">
                <label for="slug" class="block text-sm font-medium text-gray-700">
                  Slug
                </label>
                <div class="mt-1">
                  <input v-model="formQuiz.slug" id="slug" slug="slug" type="text"
                    class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md" />
                </div>
              </div>

              <div class="w-full pb-3">
                <label for="minScore" class="block text-sm font-medium text-gray-700">
                  Nilai Minimal Kelulusan
                </label>
                <div class="mt-1">
                  <input v-model="formQuiz.min_score" id="minScore" name="minScore" type="number"
                    class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border-gray-300 rounded-md"
                    placeholder="Masukkan Nilai kelulusan" />
                </div>
              </div>
              <div class="w-full">
                <div class="flex items-start pb-3">
                  <div class="flex items-center h-5">
                    <input v-model="formQuiz.is_exam" id="isExam" name="isExam" type="checkbox"
                      class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer" :class="isThereExam && (quizId != examId) ? 'cursor-not-allowed' : ''" :disabled="isThereExam  && (quizId != examId)">
                  </div>
                  <div class="ml-3 text-sm">
                    <label for="isExam" class="font-medium cursor-pointer" :class="isThereExam && (quizId != examId) ? 'text-gray-400' : 'text-gray-700'">Ujian Akhir</label>
                    <p  :class="isThereExam && (quizId != examId) ? 'text-gray-400' : 'text-gray-500'" class="cursor-pointer">Centang untuk menandakan quiz ini adalah ujian akhir</p>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button @click.prevent="submitQuiz"
                  class="inline-flex justify-center border border-solid hover:text-white font-bold text-sm px-3 py-2 rounded outline-none focus:outline-none"
                  type="button" style="transition: all .15s ease"
                  :class="quizId > 0 ? 'text-white bg-yellow-500 border-yellow-500 hover:bg-yellow-600 active:bg-yellow-600' : 'text-white bg-red-500 border-red-500 hover:bg-red-600 active:bg-red-600'"
                >
                  {{ quizId > 0 ? 'Ubah' : 'Tambah' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      </transition>
      <Toast />
      <Delete
        :display="displayDeleteQuiz"
        title="Hapus Quiz?"
        note=""
        :close="closeDeleteQuiz"
        :deleteBtn="quizDelete"
      />
      <Delete
        :display="displayDeleteQuestion"
        title="Hapus Pertanyaan?"
        note=""
        :close="closeDeleteQuestion"
        :deleteBtn="questionDelete"
      />
      <Toast />
    </div>
</template>
<script>
import {
  FilterMatchMode
} from 'primevue/api'
import Delete from '@/layout/Component/Delete'
import Back from '@/layout/Component/Back'
import Step from '@/layout/Component/Step'
import { Classroom } from '@/api/classroom'
// import moment from 'moment'
import {
  mapActions,
  mapGetters
} from 'vuex'
export default {
  components: {
    Back,
    Step,
    Delete,
  },

  data() {
    return {
      formQuiz: {
        classroom_id: 0,
        classroom_level_id: 0,
        name: '',
        slug: '',
        short_description: '',
        description: '',
        is_exam: false,
        display: 0,
        ordering: 0,
        min_score: 0,
      },
      classroomId: 0,
      quizId: 0,
      answer: [],
      selected: null,
      selectedQuiz: null,
      selectedAnswer: 0,
      payload: {
        question: '',
        choices: '',
        answer: 0,
        point: 0,
        ordering: 0,
        quiz_id: 0
      },
      format: 'trueFalse',
      displayModal: false,
      displayModalQuiz: false,
      filters: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS
        },
      },
      itemsId: 0,
      questionId: 0,
      quizzes: null,
      columns: [{
          field: 'ordering',
          header: 'Urutan'
        },

      ],
      step: 4,
      isThereExam: false,
      displayDeleteQuiz: false,
      displayDeleteQuestion: false,
      importFile: false,
      selectedFile: null,
      whatsNext: '',
      examId: 0,
    }
  },
  async created() {
    this.classroomId = this.$route.params.classroomId
    await this.getClassroomDetail()
    this.next()

    if ((this.quizList?.length == 0) || (this.classroomId != this.savedIdClassroomQuiz)) {
      await this.fetchAllQuizzes(this.classroomId)
    }
    
    this.quizzes = this.quizList
    this.checkExamExist()
    if (this.selectedQuiz == null && this.quizList?.length > 0) {
      this.selectedQuiz = this.quizList[0]
      await this.fetchAllQuestions(this.quizList[0].id)
    }
  },
  computed: {
    ...mapGetters(["classroom", "quizList", "quiz", "isLoadingQuiz", "savedIdClassroomQuiz", "isSuccessQuiz", "messageQuiz", "questionList", "question", "savedIdQuiz"]),

  },
  methods: {
    ...mapActions(["fetchDetailClassroom", "deleteQuiz", "fetchAllQuizzes", "fetchDetailQuiz", "updateQuiz", "addQuiz", "deleteQuestion", "addQuestion", "updateQuestion", "fetchAllQuestions"]),
    checkExamExist() {
      const exam = this.quizList.filter(e => e.is_exam == true)
      if(exam?.length > 0) {
        this.isThereExam = true
        this.examId = exam[0].id
      } else {
        this.isThereExam = false
        this.examId = 0
      }
    },
    async getClassroomDetail() {
      await this.fetchDetailClassroom(this.classroomId)
    },
    listQuestion(choices) {
      const formattedArray = JSON.parse(choices)
      return formattedArray
    },
    async submitQuiz() {
      this.formQuiz.classroom_id = parseInt(this.classroomId)
      this.formQuiz.classroom_level_id = parseInt(this.classroom.levels[0].id)
      this.formQuiz.min_score = parseInt(this.formQuiz.min_score)
      if(this.quizId == 0) {
        if (this.quizzes?.length) {
          this.formQuiz.ordering = Math.max.apply(Math, this.quizzes.map(function(o) { return o.ordering; })) + 1
        } else {
          this.formQuiz.ordering = 1
        }
      }
     
      if (this.formQuiz.classroom_id && this.formQuiz.classroom_level_id && this.formQuiz.ordering && this.formQuiz.name && this.formQuiz.slug) {
        if(this.quizId > 0) {
          const data = {
            id: this.quizId,
            payload: this.formQuiz
          }
          await this.updateQuiz(data)
          if (this.isSuccessQuiz) {
            await this.fetchAllQuizzes(this.classroomId)
            this.quizzes = this.quizList
            this.checkExamExist()
            // this.isThereExam = this.quizzes.some(e => e.is_exam == true)
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: this.messageQuiz,
              life: 1000
            })
            setTimeout(() => this.closeModalQuiz(), 1000)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: this.messageQuiz
            })
          }
        } else {
          await this.addQuiz(this.formQuiz)
          if (this.isSuccessQuiz) {
            await this.fetchAllQuizzes(this.classroomId)
            this.quizzes = this.quizList
            this.checkExamExist()
            // this.isThereExam = this.quizzes.some(e => e.is_exam == true)
            this.$toast.add({
              severity: 'success',
              summary: 'Success',
              detail: this.messageQuiz,
              life: 1000
            })
            setTimeout(() => this.closeModalQuiz(), 1000)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Failed',
              detail: this.messageQuiz
            })
          }
        }
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'semua form harus diisi',
          life: 3000
        })
      }
    },
    async submitQuestion() {
      if (this.selectedQuiz) {
        if (this.importFile) {
          if(this.selectedFile) {
            const payload = {
              quiz_id: this.selectedQuiz.id,
              file: this.selectedFile
            }
            await Classroom.quizQuestionImport(payload)
            .then(async res => {
              if(res.data.success) {
                await this.fetchAllQuestions(this.selectedQuiz.id)
                this.closeModal()
                this.$toast.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: 'Berhasil menambahkan pertanyaan.',
                  life: 3000
                })
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Error',
                  detail: 'Terjadi Kesalahan',
                  life: 3000
                })
              }
            })
            .catch(err => {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: err.errors[0].messageerr,
                life: 3000
              })
            })
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'File tidak boleh kosong',
              life: 3000
            })
          }
        } else {
          this.payload.quiz_id = parseInt(this.selectedQuiz.id)
          if (this.format === 'trueFalse') {
            this.payload.choices = ["Benar", "Salah"]
          } else {
            if (this.answer?.length >= 4) {
              this.payload.choices = this.answer
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Jawaban harus 4 pilihan',
                life: 3000
              })
            }
          }
  
          this.payload.answer = parseInt(this.selectedAnswer)
          this.payload.point = parseInt(this.payload.point)
          // this.payload.ordering = parseInt(this.payload.ordering)
          if (this.payload.quiz_id && this.payload.question && this.payload.choices && this.payload.point) {
            if (this.questionId != 0) {
              //edit
  
              const question = {
                id: this.questionId,
                payload: this.payload
              }
  
              await this.updateQuestion(question)
              if (this.isSuccessQuiz) {
                this.fetchAllQuestions(this.selectedQuiz.id)
                this.$toast.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: this.messageQuiz,
                  life: 1000
                })
                setTimeout(() => this.closeModal(), 1000)
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Failed',
                  detail: this.messageQuiz
                })
              }
            } else {
              //add
              await this.addQuestion(this.payload)
              if (this.isSuccessQuiz) {
                this.fetchAllQuestions(this.selectedQuiz.id)
                this.$toast.add({
                  severity: 'success',
                  summary: 'Success',
                  detail: this.messageQuiz,
                  life: 1000
                })
                setTimeout(() => this.closeModal(), 1000)
              } else {
                this.$toast.add({
                  severity: 'error',
                  summary: 'Failed',
                  detail: this.messageQuiz
                })
              }
            }
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Semua form harus diisi',
              life: 3000
            })
          }
        }
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Pilih Quiz yang ingin ditambahkan pertanyaan',
          life: 3000
        })
      }
    },
    showEditQuiz(data) {
      this.formQuiz.classroom_id = data.classroom_id
      this.formQuiz.classroom_level_id = data.classroom_level_id
      this.formQuiz.name = data.name
      this.formQuiz.slug = data.slug
      this.formQuiz.short_description = data.short_description
      this.formQuiz.description = data.description
      this.formQuiz.is_exam = data.is_exam
      this.formQuiz.display = data.display
      this.formQuiz.ordering = data.ordering
      this.formQuiz.min_score = data.min_score
      this.quizId = data.id
      this.displayModalQuiz = true
    },
    closeModalQuiz() {
      this.displayModalQuiz = false
      this.formQuiz = {}
      this.quizId = 0
    },
    closeModal() {
      this.displayModal = false
      this.questionId = 0
      this.selectedAnswer = 0
      this.payload = {
        question: '',
        choices: '',
        answer: 0,
        point: 0,
        ordering: 0,
        quiz_id: 0
      }
      // this.choices = []
      this.answer = []
      this.importFile = false
      this.selectedFile = null
      this.format = "trueFalse"
      this.fetchAllQuestions(this.selectedQuiz.id)
    },
    addQuestions() {
      this.displayModal = true
      this.questionId = 0
    },
    addQuizzes() {
      this.displayModalQuiz = true
    },
    toggleImportFile() {
      this.importFile = !this.importFile
    },
    onFileChange(event) {
      if (event.target.files[0].type == 'text/csv' || event.target.files[0].name.includes('.csv')) {
        this.selectedFile = event.target.files[0];
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Failed',
          detail: 'File harus bertipe CSV',
          life: 3000
        })
      }
    },
    editQuestions(id) {
      this.questionId = id
      this.payload = this.questionList.filter(e => e.id === id)[0]
      this.answer = JSON.parse(this.payload.choices)
      if (this.answer?.length > 2) {
        this.format = 'multiple'
      }
      this.selectedAnswer = this.payload.answer
      this.displayModal = true
    },
    showDeleteQuiz(id) {
      this.quizId = id 
      this.displayDeleteQuiz = true
    },
    closeDeleteQuiz() {
      this.quizId = 0
      this.displayDeleteQuiz = false
    },
    async quizDelete() {
      await this.deleteQuiz(this.quizId)
      if (this.isSuccessQuiz) {
          this.closeDeleteQuiz()
        this.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: this.messageQuiz,
          life: 1000
        })
        setTimeout(async () => {
          await this.fetchAllQuizzes(this.classroomId)
          this.quizzes = this.quizList
          this.isThereExam = this.quizzes.some(e => e.is_exam == true)
        }, 1000)
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Failed',
          detail: this.messageQuiz
        })
      }
    },
    showDeleteQuestion(id) {
      this.questionId = id 
      this.displayDeleteQuestion = true
    },
    closeDeleteQuestion() {
      this.questionId = null
      this.displayDeleteQuestion = false
    },
    async questionDelete() {
      await this.deleteQuestion(this.questionId)
      if (this.isSuccessQuiz) {
          this.closeDeleteQuestion()
        this.$toast.add({
          severity: 'success',
          summary: 'Success',
          detail: this.messageQuiz,
          life: 1000
        })
        setTimeout(() => this.fetchAllQuestions(this.selectedQuiz.id), 1000)
      } else {
        this.$toast.add({
          severity: 'error',
          summary: 'Failed',
          detail: this.messageQuiz
        })
      }
    },
    async onRowSelect(event) {
      this.selectedQuiz = event.data
      await this.fetchAllQuestions(event.data.id)
    },
    payloadQuiz(quiz, newOrder) {
      const form = {
        classroomId: Number(this.classroomId),
        classroomLevelId: this.classroom.levels[0].id,
        title: quiz.title,
        slug: quiz.slug,
        shortDescription: quiz.short_description,
        description: quiz.description,
        ordering: newOrder,
        display: quiz.display,
        is_exam: quiz.status,
        min_score: Number(quiz.min_score)
      }
      return form
    },

    async onRowReorder(event) {
      this.quizzes = event.value;
      for (let i = 0; i < this.quizzes.length; i++) {
        const effectedQuizzes = {
          id: this.quizzes[i]?.id,
          payload: this.payloadQuiz(this.quizzes[i], i + 1)
        }
        await this.updateQuiz(effectedQuizzes)
      }
      await this.fetchAllQuizzes(this.classroomId)
      this.quizzes = this.quizList

      this.$toast.add({
        severity: 'success',
        summary: 'success',
        detail: 'sukses dipindah',
        life: 1000
      })
    },

    next() {
      if(this.classroom?.must_submission_tab) {
        this.whatsNext = 'tugas'
      } else {
        this.whatsNext = ''
      }
    },

    nextStep() {
      let confirmation
      if (!this.quizzes?.length) {
        confirmation = confirm('Tidak ada quiz atau ujian dalam kelas ini, apakah yakin ingin ke langkah selanjutnya?')
      } else {
        confirmation = confirm('Apakah yakin ingin ke langkah selanjutnya?')
      }
      if (confirmation) {
        this.$router.push('/classroom/' + this.classroom.id + '/detail')
      }
    },
  }
}
</script>